<template>
  <div class="person_index">
    <div class="my_order">
      <div class="title">
        <span>我的订单</span>
      </div>
      <div class="status">
        <div class="status_item com_link" v-for="(item,index) in stateList" :key="index" @click="goMyOrder(item.state)">
          <el-badge :value="item.value" :max="99" :hidden="item.value>0?false:true" type="warning">
            <div class="img_box">
              <img :src="item.src" alt />
            </div>
          </el-badge>
          <span>{{item.test}}</span>
        </div>
        <div class="status_item com_link" @click="goMyOrder(0)">
          <div class="more_status">
            <i class="el-icon-arrow-right"></i>
          </div>
          <span>全部订单</span>
        </div>
      </div>
      <ul class="order_list">
        <li class="order_item" v-for="(item,index) in orderList" :key="index">
          <div class="img_box cur_pointer">
            <img :src="item.src" alt />
          </div>
          <div class="test_box">
            <span>您提交了订单，等待付款</span>
            <br />
            <span class="price">￥{{item.price}}</span>
          </div>
          <div class="fright">
            <div class="btn_detail">
              <span class="com_link">查看详情</span>
            </div>
            <div class="btn_detail">
              <span class="com_link">物流跟踪</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="my_follow">
      <div class="title">
        <span>我的关注</span>
      </div>
      <div class="follow_type">
        <div class="follow_item com_link" @click="linkUrlReload('/personalCenter/followGoods')">
          <div class="number">
            <el-badge value="2个降价">
              <span class="num">15</span>
            </el-badge>
          </div>
          <span>商品收藏</span>
        </div>
        <div class="follow_item com_link" @click="linkUrlReload('/personalCenter/followBrand')">
          <div class="number">
            <el-badge value="2个降价" :hidden="true">
              <span class="num">62</span>
            </el-badge>
          </div>
          <span>品牌关注</span>
        </div>
      </div>
      <div class="brow_history">
        <span>浏览记录</span>
        <el-button class="btn">更多></el-button>
      </div>
      <div class="my_swiper">
        <Swiper class="swiper_box" ref="mySwiper" :options="swiperOption">
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img :src="require('@/assets/img/main-2.jpg')" alt />
          </swiper-slide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  metaInfo: { title: "个人中心" },
  name: "personIndex",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    orderPathName: {
      type: String,
      default: "myOrder",
    },
  },
  data() {
    return {
      stateList: [
        {
          value: 12,
          src: require("@/assets/img/sa-10.png"),
          test: "待付款",
          state: 1,
        },
        {
          value: 1,
          src: require("@/assets/img/sa-8.png"),
          test: "待收货",
          state: 3,
        },
        {
          value: 11,
          src: require("@/assets/img/sa-6.png"),
          test: "待评价",
          state: 4,
        },
        {
          value: 120,
          src: require("@/assets/img/fgg--icon-1.jpg"),
          test: "退换/售后",
          state: 9,
        },
      ],
      orderList: [
        {
          src: require("@/assets/img/space2.jpg"),
          price: "2229.00",
        },
        {
          src: require("@/assets/img/space2.jpg"),
          price: "22291.00",
        },
        {
          src: require("@/assets/img/space2.jpg"),
          price: "22292.00",
        },
        {
          src: require("@/assets/img/space2.jpg"),
          price: "22293.00",
        },
      ],
      //swiper配置项
      swiperOption: {
        spaceBetween: 6, //间隔距离
        autoplay: 3000,
        loop: true,
        slidesPerView: 4, //默认1, 同时显示的slides数量,auto 代表根据轮播图的高度排列
        grabCursor: true,
        autoplayDisableOnInteraction: false, //操作后还可操作
        setWrapperSize: true, //在对flexbox布局不好时需要
        // preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件。
        // simulateTouch: false, //鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
      },
    };
  },
  methods: {
    linkUrlReload(url) {
      let newUrl = this.$router.resolve(url);
      window.open(newUrl.href, "_self");
    },
    goMyOrder(type) {
      // console.log(type);
      if (type > 5) {
        return;
      }
      // 可以使用push 用户类型没有改变
      this.$router.push({
        name: this.orderPathName,
        params: { type },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.person_index {
  padding-top: 16px;
  margin-bottom: 120px;
  color: #1a1a1a;
  display: flex;
  justify-content: space-between;
  .my_order {
    width: calc(100% - 390px);
    .title {
      padding: 0px 0 19px 31px;
      font-size: 18px;
      font-weight: 500;
    }
    .status {
      height: 140px;
      box-sizing: border-box;
      border-top: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      padding-left: 31px;
      display: flex;
      align-items: center;
      .status_item {
        text-align: center;
        height: 82px;
        margin-right: 74px;
        color: #000000;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &:last-child {
          margin-right: 0;
        }
        .img_box {
          height: 50px;
          img {
            width: auto;
            height: auto;
            max-height: 100%;
          }
        }
        .more_status {
          width: 50px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #f4f4f4;
          border-radius: 50%;
          font-size: 28px;
          margin: 0 auto;
        }
      }
    }
    .order_list {
      .order_item {
        height: 116px;
        border-bottom: 1px solid #f4f4f4;
        box-sizing: border-box;
        font-size: 12px;
        display: flex;
        align-items: center;
        position: relative;
        .img_box {
          width: 112px;
          height: 73px;
          margin-right: 31px;
          img {
            height: auto;
            max-height: 100%;
          }
        }
        .test_box {
          line-height: 30px;
          .price {
            color: #ff0000;
          }
        }
        .fright {
          display: flex;
          position: absolute;
          right: 17px;
          top: 50%;
          margin-top: -8px;
        }
        .btn_detail {
          padding: 0 27px;
          border-right: 1px solid #e5e5e5;
          &:last-child {
            border: none;
          }
        }
      }
    }
  }
  .my_follow {
    width: 372px;
    .title {
      padding: 0px 0 19px 20px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
    }
    .follow_type {
      height: 140px;
      box-sizing: border-box;
      border: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      padding-left: 30px;
      margin-bottom: 24px;
      .follow_item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 64px;
        margin-right: 66px;
        &:last-child {
          margin-right: 0px;
        }
        .number {
          font-size: 20px;
          .num {
            padding-right: 10px;
          }
        }
      }
    }
    .brow_history {
      padding-left: 19px;
      padding-right: 9px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      display: flex;
      justify-content: space-between;
      margin-bottom: 19px;
      .btn {
        border: none;
        padding: 0px;
      }
    }
    .my_swiper {
      border: 1px solid #e5e5e5;
      padding: 17px 20px;
      .swiper_box {
        width: 100%;
        height: 78px;
      }
    }
  }
  /deep/ .el-badge__content--warning {
    background-color: @themeColor;
  }
}
</style>